var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection07(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22172",
    "data-name": "\\uADF8\\uB8F9 22172",
    transform: "translate(8892 -5419)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1579",
    "data-name": "\\uD0C0\\uC6D0 1579",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-8892 5419)",
    fill: "#28af00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10375",
    "data-name": "\\uD328\\uC2A4 10375",
    d: "M2.776,2.238H.6V5.919H-1.523V-4.318H2.935a3.632,3.632,0,0,1,2.459.792,3.068,3.068,0,0,1,.917,2.452,3.142,3.142,0,0,1-.917,2.563A4.037,4.037,0,0,1,2.776,2.238Zm1-2.132a1.481,1.481,0,0,0,.417-1.167A1.386,1.386,0,0,0,3.772-2.2a1.823,1.823,0,0,0-1.177-.34H.6V.474H2.595A1.742,1.742,0,0,0,3.776.106Z",
    transform: "translate(-8884.394 5428.2)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection07);
export default __webpack_public_path__ + "static/media/inspection_07.93709f1c131e31d539454a6509f1bca7.svg";
export { ForwardRef as ReactComponent };